import * as actionTypes from './../actions/animalTypeAction';

const initialState = {
  selected: null,
  selectedId: null,
  data: [],
  pending: true,
  error: null,
  ready: false,
  animalType: null,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      return {
        ...state,
        selected: action.selected,
        animalType: action.animalType,
        selectedId: state.data.data[action.selected].id
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selected: 0,
        animalType: state.data.data[0].type,
        ready: true,
        selectedId: state.data.data[0].id
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
